import api from './api';

// Login
// POST /api/auth/login
// Request: { email: string, password: string }
// Response: { accessToken: string, refreshToken: string }
export const login = async (email: string, password: string) => {
  try {
    const response = await api.post('/api/auth/login', { email, password });
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Register
// POST /api/auth/register
// Request: { email: string, password: string, name?: string }
// Response: { email: string }
export const register = async (email: string, password: string) => {
  const response = await api.post('/api/auth/register', { email, password, name: '' });
  return response.data;
};

// Refresh Token
// POST /api/auth/refresh
// Request: { refreshToken: string }
// Response: { accessToken: string, refreshToken: string }
export const refreshToken = async (token: string) => {
  try {
    const response = await api.post('/api/auth/refresh', { refreshToken: token });
    return response.data;
  } catch (error) {
    console.error('Token refresh error:', error);
    throw error;
  }
};

// Logout
// POST /api/auth/logout
// Response: { success: boolean, message: string }
export const logout = async () => {
  const response = await api.post('/api/auth/logout');
  return response;
};
